import { trpc } from 'api'
import { reloadAsync, useUpdates, fetchUpdateAsync } from 'expo-updates'
import { useTranslation } from 'react-i18next'
import useUpdateModal from 'hooks/useUpdateModal'
import ScreenTemplate from '@shell/ScreenTemplate'
import VersionIcon from '@shell/Version/VersionIcon'
import { findVersionInObject } from '@shell/Version/helpers'
import { useEffect, useState } from 'react'

function UpdateScreenModal() {
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const { t } = useTranslation(['ui', 'app'])
  const text = 'app:update'
  const { availableUpdate, isDownloading, downloadedUpdate } = useUpdates()

  const { data: server } = trpc.version.useQuery({})
  const version = findVersionInObject(availableUpdate) || server?.version

  const onPress = async () => {
    if (downloadedUpdate) {
      // Update is already downloaded, reload
      reloadAsync()
      return
    }

    setIsLoading(true)
    // If we are already downloading, do nothing
    if (isDownloading) {
      return
    }
    // Fetch update
    fetchUpdateAsync()
  }

  useEffect(() => {
    if (!downloadedUpdate || !isLoading) {
      return
    }
    // If we triggered the loading state and have the update downloaded, reload
    reloadAsync()
  }, [isLoading, downloadedUpdate])

  useEffect(() => {
    if (!downloadedUpdate && !isDownloading) {
      fetchUpdateAsync()
    }
  }, [downloadedUpdate, isDownloading])

  return (
    <ScreenTemplate
      absolute
      iconComponent={<VersionIcon version={version} />}
      title={t(`${text}.header.title`)}
      desc={t(`${text}.header.desc`)}
      buttons={[
        {
          label: t('ui:install'),
          onPress,
          loading: isLoading,
        },
      ]}
    />
  )
}

const UpdateScreen = () => {
  const { isOpen, isForced } = useUpdateModal()

  const isVisible = isOpen || isForced

  if (!isVisible) return null

  return <UpdateScreenModal />
}

export default UpdateScreen
